import React, { useEffect, useState } from "react";

const CKEditor = ({ initialData, data, onEditorChange, CSRFToken, type, id }) => {
    const [ckEd, setCkEd] = useState(null);


    useEffect(() => {
        if (initialData && ckEd) {
            ckEd.instances.editor.setData(initialData);
        }
    }, [initialData, ckEd]);

    useEffect(() => {
        if (ckEd){
            var editor = ckEd.instances.editor;
            if (editor) {
                editor.destroy(true);
            }
            ckEd.replace("editor", {...configuration,
                uploadUrl: `/api/flat/save-image/${type}/${id}`,
                filebrowserImageUploadUrl: `/api/flat/save-image/${type}/${id}`
            });
            ckEd.instances.editor.on("change", onEditorChange);
        }
    }, [type, id, ckEd]);

    const configuration = {
        // filebrowserBrowseUrl: "/browser/browse.php",
        removeDialogTabs: 'image:advanced;image:Link',
        height: 400,
        fileTools_requestHeaders: {
            'X-CSRF-TOKEN': CSRFToken,
        },
        //uploadUrl: `/api/flat/save-image/${type}/${id}`,
        //filebrowserImageUploadUrl: `/api/flat/save-image/${type}/${id}`,
        toolbar: [
            { name: "document", items: ["Source"] },
            {
                name: "clipboard",
                groups: ["clipboard", "undo"],
                items: ["PasteText", "-", "Undo", "Redo"]
            },
            {
                name: "basicstyles",
                groups: ["basicstyles", "cleanup"],
                items: [
                    "Bold",
                    "Italic",
                    "Subscript",
                    "Superscript",
                    "-",
                    "RemoveFormat"
                ]
            },
            {
                name: "paragraph",
                groups: ["list", "indent", "blocks", "align", "bidi"],
                items: [
                    "NumberedList",
                    "BulletedList",
                    "-",
                    "Outdent",
                    "Indent",
                    "-",
                    "Blockquote",
                    // "CreateDiv",
                    "-",
                    "JustifyLeft",
                    "JustifyCenter",
                    "JustifyRight",
                    "JustifyBlock"
                ]
            },
            "/",
            { name: "links", items: ["Link", "Unlink"] },
            {
                name: "insert",
                items: ["Image", "Table", "Anchor", "HorizontalRule", "SpecialChar"]
            },
            { name: "styles", items: ["Format"] }
        ]
    };


    const initializeCK = () => {
        window.CKEDITOR.replace("editor", configuration);
        setCkEd(window.CKEDITOR);
    }

    useEffect(() => {
        const script = document.createElement('script');
        script.src = "https://cdn.ckeditor.com/4.14.1/full/ckeditor.js";
        script.async = true;
        script.onload = function () {
            initializeCK();
        };
        document.body.appendChild(script);
        return () => {
            document.body.removeChild(script);
        }
    }, []);
    return (
        <textarea
            name="editor"
            cols="100"
            rows="6"
        />
    )

}
export default CKEditor;
